var _excluded = ["value", "showDate", "showTime"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { format } from 'date-fns';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

var DateTime = function DateTime(_ref) {
  var value = _ref.value,
      _ref$showDate = _ref.showDate,
      showDate = _ref$showDate === void 0 ? true : _ref$showDate,
      _ref$showTime = _ref.showTime,
      showTime = _ref$showTime === void 0 ? true : _ref$showTime,
      props = _objectWithoutProperties(_ref, _excluded);

  var dateTimeFormat = function () {
    var dateFormat = 'yyyy-MM-dd';
    var timeFormat = 'HH:mm:ss';

    if (showDate && showTime) {
      return "".concat(dateFormat, " ").concat(timeFormat);
    }

    return showDate ? dateFormat : timeFormat;
  }();

  if (!value) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: "-"
    });
  }

  var text = function () {
    try {
      return format(new Date(value), dateTimeFormat);
    } catch (e) {
      return e.message;
    }
  }();

  return /*#__PURE__*/_jsx("time", _objectSpread(_objectSpread({
    dateTime: value
  }, props), {}, {
    children: text
  }));
};

export default DateTime;
//# sourceMappingURL=es/index.js.map